<div class="page-container">
  <div class="card-container">
    <div class="gif-placeholder">
      <video class="gif-placeholder__video" autoplay [muted]="true" loop playsinline preload="auto">
        <source src="assets/video/welcome.mp4" type="video/mp4" />
      </video>
    </div>
    <p class="instruction-text">あなたの組織情報は・・・</p>

    <div class="info-highlight-box">
      {{ company?.corporateNumber }}&nbsp;&nbsp;{{ company?.organizationFormalName }}
    </div>

    <div class="action-group">
      <button class="btn-retry" (click)="goBack()">もう一度修正したい</button>
      <button class="btn-submit" (click)="goNext()">このまま進めたい</button>
    </div>
  </div>
</div>
